import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Zap } from 'lucide-react';

export const ContactForm = () => {
  return (
    <section className="py-20 md:py-32 px-6 md:px-12 bg-gradient-to-b from-secondary/5 to-background" data-testid="contact-form-section">
      <div className="container mx-auto max-w-5xl">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="text-sm font-medium tracking-wide uppercase text-primary bg-primary/10 px-4 py-2 rounded-full inline-block mb-4">
              Ready to Transform Your Delivery?
            </span>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Stop Losing Orders. Start Making More.
            </h2>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Click below to start your free 30-day trial. No credit card. No commitment. Just results.
            </p>

            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center">
                  <Zap className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <p className="font-semibold text-foreground">Live in 24 hours</p>
                  <p className="text-sm text-muted-foreground">Start taking automated orders tomorrow</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center text-2xl">✓</div>
                <div>
                  <p className="font-semibold text-foreground">No credit card required</p>
                  <p className="text-sm text-muted-foreground">Full 30-day access. Zero risk. Cancel anytime.</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center text-2xl">✓</div>
                <div>
                  <p className="font-semibold text-foreground">Free menu setup included</p>
                  <p className="text-sm text-muted-foreground">We help you get started the right way</p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-primary/10 rounded-2xl border-l-4 border-primary">
              <p className="text-foreground font-semibold">
                ⏰ <span className="text-primary">Limited Time:</span> First 50 signups get 1 month free setup + training (worth $500)
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-border/50 flex flex-col items-center justify-center text-center h-full"
          >
            <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mb-6">
              <Zap className="w-10 h-10 text-primary" />
            </div>

            <h3 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Your 30-Day Free Trial
            </h3>

            <p className="text-muted-foreground mb-10 max-w-sm">
              Join thousands of other restaurants already automating their WhatsApp orders and increasing sales.
            </p>

            <a
              href="https://app.easyorder.delivery/informacoes"
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 py-5 text-xl font-bold shadow-lg hover:shadow-xl transition-all inline-flex items-center justify-center gap-3 group"
            >
              Start Free Trial Now
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
            </a>

            <p className="text-sm text-muted-foreground mt-6 flex items-center gap-2 justify-center">
              <span className="text-green-500 text-lg">🔒</span> Auto-setup. 100% secure.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;